module.exports = __webpack_public_path__ + "img/stock_transfer.3d8b9db5.svg";